<template>
  <div class="ovo">
    <AmountDisplayer/>
    <Back/>
    {{$t('ovo.title')}}
    <van-field v-model="ovoNumber" :placeholder="$t('ovo.placeHolder')"/>
    <div class="order-payment__button-container" >
      <van-button class="button-container__pay-button" type="primary" :disabled="buttonDisabled" @click="handleItemClick">
        {{ $t('tappay.next') }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { applyPay } from '@/api'
import { tappayScreen } from '@/utils/screen'
export default {
  name: 'Ovo',
  props: {
    isPrd: {
      type: Boolean,
      default: false
    },
    payChannelID: {
      type: [String, Number],
      default: ''
    },
    payToken: {
      type: String,
      default: ''
    }
  },
  created () {
    tappayScreen()
  },
  data () {
    return {
      ovoNumber: ''
    }
  },
  computed: {
    buttonDisabled () {
      return !/[0-9]/g.test(this.ovoNumber)
    }
  },
  methods: {
    handleItemClick (item) {
      applyPay({
        pay_channel_id: this.payChannelID,
        payToken: this.payToken,
        card: JSON.stringify({ content: this.ovoNumber })
      }).then(res => {
        this.$emit('goTo', { component: 'Result', type: 'unknown', ovo: true })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.ovo {
  padding: 24px 16px 0;
  background: #fff;
  width:100%;
  height:100vh;
  ::v-deep .van-cell__value {
    border: 1px #737373 solid;
    border-radius: 2px;
  }
  ::v-deep .van-cell::after{
    border: none;
  }
  .order-payment__button-container {
    position: fixed;
    bottom: 24px;
    left: 0;
    right: 0;
    padding: 0 16px;

    .van-button--primary {
      border-radius: 8px;
      width: 100%;
    }

    &__pay-button {
      height: 52px;
      font-size: 16px;
    }
  }
}
</style>
